import { Axis } from 'components/node_settings/AxesEnabledDisplay';
import { V4SensorSettings } from 'custom_hooks/data_hooks/v4_sensor_settings/useV4SensorSettings';

export function anyVibrationAxisEnabled(settings: V4SensorSettings): boolean {
    return settings.vibrationX || settings.vibrationY || settings.vibrationZ;
}

export function getEnabledAxes(settings: V4SensorSettings): Axis[] {
    const axes: Axis[] = [];
    if (settings.vibrationX) {
        axes.push('X');
    }
    if (settings.vibrationY) {
        axes.push('Y');
    }
    if (settings.vibrationZ) {
        axes.push('Z');
    }
    return axes;
}
